<nav class="navbar navbar-expand-lg w-100 position-fixed" [ngClass]="{'transparent': isTransparent}" style="z-index: 1000;">
  <div class="container-fluid">
    <!-- Logo and Market link -->
    <a id="titleLink" class="navbar-brand me-4" routerLink="{{homeRoute}}">
      <img src="/assets/images/organisations/gov/site_logo.png" class="logo" alt="{{ title }}" width="40">
    </a>

    <!-- Navbar Toggle Button for Mobile View -->
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Collapsible Navbar Menu -->
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item me-3">
          <a class="nav-link active btn btn-light" aria-current="page" routerLink="{{homeRoute}}">
            <fa-icon class="me-2 fa-lg" [icon]="faHouse"></fa-icon> <strong>Domov</strong>
          </a>
        </li>
        <li class="nav-item me-3">
          <a class="nav-link active btn btn-light" aria-current="page" routerLink="{{marketRoute}}">
            <fa-icon class="me-2 fa-lg" [icon]="faShop"></fa-icon> <strong>Tržnica</strong>
          </a>
        </li>
        <!-- Add more items here if needed 
        <li class="nav-item me-3">
          <a class="nav-link active btn btn-light" aria-current="page" routerLink="{{farmsRoute}}">
            <fa-icon class="me-2 fa-lg" [icon]="faTractor"></fa-icon> <strong>Ponudniki</strong>
          </a>
        </li>-->
        <li class="nav-item me-3">
          <a class="nav-link active btn btn-light" aria-current="page" routerLink="{{calendarRoute}}">
            <fa-icon class="me-2 fa-lg" [icon]="faCalendar"></fa-icon> <strong>Koledar</strong>
          </a>
        </li>
        <!--<li class="nav-item me-3">
          <a class="nav-link active btn btn-light" aria-current="page" routerLink="{{helpRoute}}">
            <fa-icon class="me-2 fa-lg" [icon]="faCircleInfo"></fa-icon> <strong>Pomoč</strong>
          </a>
        </li>-->

        <!-- Dropdown for Organizations -->
        <li class="nav-item dropdown me-3">
          <a class="nav-link dropdown-toggle btn btn-light" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            <fa-icon class="me-2 fa-lg" [icon]="faBuilding"></fa-icon> <strong>Organizacije</strong>
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
            <li *ngFor="let org of organisations.slice(1)">
              <a class="dropdown-item" [routerLink]="['/organisation', org.slug]">
                {{ org.name }}
              </a>
            </li>            
          </ul>
        </li>      
      </ul>

      <!-- Right-aligned Items -->
      <div class="d-flex align-items-center">
        <!-- Register Button (Visible when not logged in) -->
        <a *ngIf="!isLoggedIn && !isAdminLoggedIn" [routerLink]="'/register'" class="btn btn-light nav-link p-2">
          <fa-icon class="me-2 mb-0" [icon]="faRightToBracket"></fa-icon><strong>Prijavi se</strong>
        </a>

        <a *ngIf="isAdminLoggedIn">
          <fa-icon class="me-5 mb-0" [icon]="faUserTie"></fa-icon>
        </a>
        
        <!-- Logout Button (Visible when logged in) -->
        <button *ngIf="isLoggedIn || isAdminLoggedIn" (click)="logout()" class="btn btn-light nav-link p-2">
          <fa-icon class="me-2 mb-0" [icon]="faRightFromBracket"></fa-icon><strong>Izpis</strong>
        </button>

        <!-- Profile Farm Page Button (Visible when logged in) -->
        <button *ngIf="isLoggedIn && userHasFarm && !isAdminLoggedIn" class="btn btn-light ms-2 nav-link p-2" [routerLink]="adminFarmProfileRoute">
          <fa-icon class="me-2 mb-0" [icon]="faHouse"></fa-icon><strong>Profil kmetije</strong>
        </button>
        <button *ngIf="isLoggedIn && !userHasFarm && !isAdminLoggedIn" class="btn btn-light ms-2 p-2" [routerLink]="farmRegisterRoute">
          <strong>Registriraj Kmetijo</strong>
        </button>
        <button *ngIf="isLoggedIn && !isAdminLoggedIn" [routerLink]="'/user-profile'" class="btn btn-light ms-2 nav-link p-2">
          <fa-icon class="me-2 mb-0" [icon]="faUser"></fa-icon><strong>{{ currentUserUsername }}</strong>
        </button>
      </div>
    </div>
  </div>
</nav>

<!-- Main Content -->
<div style="">
  <router-outlet></router-outlet>
</div>

<app-footer [onRegisterPage]="onRegisterPage" [bgColor]="footerBgColor"></app-footer>